import { useState } from "react";
import { Cpu, LogIn, ShieldCheck } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { TID } from "../lib/testIds";

const BG = "https://images.unsplash.com/photo-1637946175559-22c4fe13fc54?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbWluaW1hbCUyMGFic3RyYWN0fGVufDB8fHx8MTc4ODAzMjI4MHww&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { status, error, login } = useAuth();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (status === "authed") return <Navigate to="/" replace />;

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    await login(password);
    setLoading(false);
  }

  return (
    <div className="min-h-screen bg-black text-zinc-100 relative overflow-hidden">
      <img
        src={BG}
        alt=""
        className="absolute inset-0 h-full w-full object-cover opacity-20 pointer-events-none"
      />
      <div className="absolute inset-0 krai-grid-bg opacity-40 pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black pointer-events-none" />

      <div className="relative z-10 min-h-screen grid place-items-center px-6">
        <div className="w-full max-w-[420px]">
          <div className="flex items-center gap-2.5 mb-8">
            <div className="h-9 w-9 rounded-md bg-white text-black grid place-items-center">
              <Cpu className="h-4 w-4" />
            </div>
            <div className="leading-tight">
              <div className="text-sm font-semibold tracking-tight">KRAI CONNECT</div>
              <div className="text-[11px] text-zinc-500 font-mono">panel privado · v0.1.0</div>
            </div>
          </div>

          <div className="rounded-md border border-zinc-800 bg-zinc-950/80 backdrop-blur-sm p-6">
            <h1 className="text-2xl font-semibold tracking-tight text-white">
              Acceso restringido
            </h1>
            <p className="mt-1.5 text-sm text-zinc-400">
              Introduce la contraseña de administrador para continuar.
            </p>

            <form onSubmit={submit} data-testid={TID.login.form} className="mt-6 space-y-4">
              <div className="space-y-2">
                <label className="text-xs uppercase tracking-widest text-zinc-500 font-mono">
                  Contraseña
                </label>
                <input
                  type="password"
                  data-testid={TID.login.password}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoFocus
                  className="w-full h-11 px-3 rounded-md bg-zinc-900 border border-zinc-800 text-zinc-100 placeholder-zinc-600 outline-none focus:border-zinc-400 focus:ring-1 focus:ring-zinc-400 transition-colors duration-150 font-mono text-sm"
                  placeholder="••••••••••"
                />
              </div>
              {error && (
                <div
                  data-testid={TID.login.error}
                  className="text-xs text-red-400 border border-red-900/60 bg-red-950/30 rounded-md px-3 py-2"
                >
                  {error}
                </div>
              )}
              <button
                type="submit"
                data-testid={TID.login.submit}
                disabled={loading || !password}
                className="w-full h-11 rounded-md bg-white text-black font-medium hover:bg-zinc-200 disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center gap-2 transition-colors duration-150"
              >
                <LogIn className="h-4 w-4" />
                {loading ? "Comprobando…" : "Entrar"}
              </button>
            </form>

            <div className="mt-6 pt-4 border-t border-zinc-800 text-[11px] text-zinc-500 flex items-center gap-2">
              <ShieldCheck className="h-3.5 w-3.5 text-emerald-400" />
              JWT + contraseña por variable de entorno. Sin usuarios públicos.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
